import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import React from "react";
import {NFTextInput} from "src/components/Shared/NewForms/NFTextInput";
import {NFDateInput} from "src/components/Shared/NewForms/NFDateInput";
import {NFLookupCompany} from "src/components/Shared/NewForms/NFLookupCompany";
import {NFLookupWarehouse} from "src/components/Shared/NewForms/NFLookupWarehouse";
import {NFLookupDivision} from "src/components/Shared/NewForms/NFLookupDivision";
import {NFLookupCurrency} from "src/components/Shared/NewForms/NFlookupCurrency";
import {NFLookupVendor} from "src/components/Shared/NewForms/NFLookupVendor";
import {NFLookupContract} from "src/components/Shared/NewForms/NFLookupContract";

export const VendorInvoicesDetailMain = () => {
    const { watch } = useFormContext();
    const { t } = useTranslation();

    return (
        <>
            <Row>
                <Col sm={6}>
                    <NFTextInput
                        title={t("Document#")}
                        fieldName={"documentNumber"}
                        disabled
                    />
                </Col>
                <Col sm={3}>
                    <NFDateInput
                        title={t("DocumentDate")}
                        fieldName={"documentDate"}
                        required={true}
                    />
                </Col>
                <Col sm={3}>
                    <NFDateInput
                        title={t("ApprovalDate")}
                        fieldName={"approvalDate"}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupCompany
                        fieldName={"companyId"}
                        title={t("Company")}
                        required={true}
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupWarehouse
                        fieldName={"warehouseId"}
                        title={t("Warehouse")}
                        companyId={watch("companyId")}
                        required={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupDivision
                    companyId={watch('companyId')}
                        fieldName={"divisionId"}
                        title={t("Division")}
                        required={true}
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupCurrency
                        fieldName={"currencyId"}
                        title={t("Currency")}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <NFLookupVendor
                        fieldName={"vendorId"}
                        title={t("Vendor")}
                        required={true}
                    />
                </Col>
                <Col sm={6}>
                    <NFLookupContract
                        fieldName={"contractId"}
                        title={t("Contract")}
                    />
                </Col>
            </Row>
            {/*<Row>*/}
            {/*    <Col sm={12}>*/}
            {/*        <TextBox validationStatus={"invalid"}>*/}
            {/*            <TextBoxButton name={"test"}   location={"after"} options={{*/}
            {/*                icon: "fa-brands fa-openid"*/}
            {/*            }}                      />*/}
            {/*        </TextBox>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
        </>
    );
};
